<template>
  <div class="mb-5">
    <template v-if="$helper.currencyOptions.length > 1">
      <v-tabs
        v-model="tab"
        color="primary"
        slider-color="primary"
        background-color="white"
        class="tab-custom-inline"
        @change="onTabChange"
      >
        <template v-if="$helper.currencyOptions.length > 1">
          <template v-for="currency in $helper.currencyOptions">
            <v-tab :value="currency.value" :href="`#${currency.value}`" :key="currency.value">
              <img :src="`/images/currency/${currency.value}.svg`" :alt="currency.value" class="mr-2 tab-icon-flag">
              {{ currency.tabName }}
            </v-tab>
          </template>
        </template>
      </v-tabs>
      <v-tabs-items v-model="currentTab">
        <v-tab-item v-for="currency in $helper.currencyOptions" :key="currency.value" :value="`${currency.value}`">
          <MarketSettingPenaltyComponent v-if="!isMainLoading" 
           :isMainLoading="isMainLoading"
           :tabType="currency.value"
           :reload="isReload"/>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-else>
      <MarketSettingPenaltyComponent  :isMainLoading="isMainLoading" :tabType="tab"/>
    </template>

    <ConfirmDialog v-model="dialogGoNextTab" :title="$t('caution')"
      :text="$t('validate.your_input_data_has_not_been_saved')"
      :subText="$t('validate.confirm_to_continue')"
      :textClass="'text-center fs-14'"
      :textBtnOk="$t('confirm')" 
      :textBtnCancel="$t('cancel')"
      :type="'warning'"
      @onOk="confirmTabChange"
      @onCancel="cancelTabChange" />
  </div>
</template>

<script>
import MarketSettingPenaltyComponent from "@/components/MarketSettingPenalty.component.vue";
import ConfirmDialog from "@/components/ConfirmDialog.component";
export default {
  components: {
    MarketSettingPenaltyComponent,
    ConfirmDialog
  },
  data() {
    return {
      tab: this.$globalCurrencyCode,
      isMainLoading: false,
      marketId: null,
      projectId: null,
      dialogGoNextTab: false,
      nextTab: null,
      allowTabChange: false,
      currentTab: this.$globalCurrencyCode,
      tempTab: this.$globalCurrencyCode,
      isReload: false,
    }
  },
  methods: {
    cancelTabChange() {
      this.dialogGoNextTab = false;
    },
    confirmTabChange() {
      this.tab = this.tempTab;
      this.currentTab = this.tempTab;
      this.$emit('onSelectTab', this.tempTab);
      this.dialogGoNextTab = false;
      this.isReload = true;
      setTimeout(() => {
        this.isReload = false;
      }, 100);
    },
    onTabChange(data) {
      this.$nextTick(() => {
        this.tempTab = data;
        this.tab = this.currentTab;
        this.dialogGoNextTab = true;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.tab-custom-inline{
  
  .v-tabs{
    max-width: 480px;
    pointer-events: none;
  }
  .v-slide-group__content {
    background: #f5f5f5;
  }
  .v-tab.v-tab {
    background: #fff;
  }
}
.fs-14 {
  font-size: 14px;
}

</style>